import type { ConfluenceBlogPost } from '../../types';

export const isConfluenceBlogPost = (entity: any): entity is ConfluenceBlogPost =>
	entity.__typename === 'ConfluenceBlogPost';

export const getConfluenceBlogPostLink = (post: ConfluenceBlogPost): string | null => {
	const { base, webUi } = post.links ?? {};
	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}
	return `${base}${webUi}`;
};
